import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosCall from 'axios';
// import { act } from 'react-dom/test-utils';
import CONSTANTURL from '../../../globals/common_utilities/constanturls';
import { API } from '../../../globals/constants';

// const initialState = [
// 	{
// 		loading: false,
// 		Response: [],
// 		error: '',
// 	},
// ];

const initialState = {
	id: '',
	deleteList: [],
	checkedList: [],
	showdetails: false,
	showFilterFB: false,
};

// const response = useSelector((state) => state.login);

export const trainingCenterAPI = createAsyncThunk(
	'trainCenter/trainingCenterAPI',
	async () => {
		console.log('efgj:::::');

		// console.log('reduxTCResponse', token);

		return axiosCall
			.get(
				`${
					CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
					API.END_POINTS.TRAININGCENTER_ENDPOINT
				}`
			)
			.then((response) => response.data);
	}
);

const trainingCenterSlice = createSlice({
	name: 'trainCenter',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(trainingCenterAPI.pending, (state) => {
			return (state.loading = true);
		});
		builder.addCase(trainingCenterAPI.fulfilled, (state, action) => {
			return (
				(state.loading = false),
				(state.Response = action.payload),
				(state.error = '')
			);
		});
		builder.addCase(trainingCenterAPI.rejected, (state, action) => {
			return (
				(state.loading = false),
				(state.Response = []),
				(state.error = action.error.message)
			);
		});
	},
});

const trainingCenterIdSlice = createSlice({
	name: 'trainingCenterID',
	initialState,
	reducers: {
		settrainingCenterID: (state, action) => {
			state.id = action.payload;
			console.log('settrainingCenterID', state.id);
		},
		showtrainingDetails: (state, action) => {
			// console.log('Cake Action :', action);
			state.showdetails = action.payload;
		},
		setdeleteList: (state, action) => {
			state.deleteList = [...state.deleteList, action.payload];
		},
		setemptyDeleteList: (state) => {
			state.deleteList = [];
		},
		setfliterDeleteList: (state, action) => {
			state.deleteList = action.payload;
		},
		setcheckedList: (state, action) => {
			// console.log('reduxAction', action.payload);
			state.checkedList = [...state.checkedList, action.payload];
			// console.log('payloadSet', state.checkedList);
		},
		setemptycheckedList: (state, action) => {
			state.checkedList = [];
		},
		setflitercheckedList: (state, action) => {
			state.checkedList = action.payload;
		},
		USER_LOGOUT: (state, action) => {
			state.checkedList = [];
		},
		hideFilter: (state, action) => {
			state.showFilterFB = action.payload;
		},
	},
});

export const {
	settrainingCenterID,
	showtrainingDetails,
	setdeleteList,
	setcheckedList,
	setemptyDeleteList,
	setfliterDeleteList,
	setflitercheckedList,
	setemptycheckedList,
	USER_LOGOUT,
	hideFilter,
} = trainingCenterIdSlice.actions;

export const TC = {
	trainingCenterSlice: trainingCenterSlice.reducer,
	trainingCenterIdSlice: trainingCenterIdSlice.reducer,
};
